;(function($) {

    'use strict';
    
    /**
     * Greentic Form Validation
     * @author romain@greentic.net 20171020
     */
    $(function() {
    
        var selectors = {
            controls: '.form-group.validate input, .form-group.validate select, .form-group.validate textarea'
        };
        $(document).on('submit.validate', 'form.validate', function(e) {
            e.preventDefault();
            var $form = $(this);
            if ($form.validate({fields: $form.find(selectors.controls)}, function(validated) {
                validated && $(document).off('submit.validate') && $form.submit();
            }));
        });
        
        $(document).on('blur', selectors.controls, function() {
            $(this).closest('form').validate({fields: this});
        });
        
        $(document).on('click', 'input[type=checkbox], input[type=radio]', function(event) {
            var $input = $(this);
            var $siblings = $input.closest('form').find('input[name=' + $input.attr('name') + ']');
            $siblings.closest('label').removeClass('selected');
            $siblings.filter(':checked').each(function() {
                $(this).closest('label').addClass('selected');
            });
        });
    
        $('#form--contact').each(function() {
            var $form = $(this);
            var sections = {
                $steps: $('section.step'),
                $switcher: $('section.step--switcher'),
                $informations: $('section.step--informations'),
                $project: $('section.step--project'),
                $job: $('section.step--job'),
                $other: $('section.step--other'),
                $feedback: $('section.step--feedback'),
                $success: $('section.step--feedback .success'),
                $error: $('section.step--feedback .error')
            };
            
            sections.$steps.hide();
            sections.$informations.hide();
            sections.$switcher.show();
            sections.$project.show();
            sections.$switcher.find('select').on('change', function() {
                sections.$steps.hide();
                sections.$switcher.show();
                sections.$steps.filter('.' + $(this).find('option:selected').data('step')).show();
            });
            sections.$success.hide();
            sections.$error.hide();
    
            sections.$steps.find('button.btn-prev[data-step]').on('click', function(event) {
                event.preventDefault();
                sections.$steps.hide();
                sections.$steps.filter('.' + $(this).data('step')).show();
                sections.$steps.filter('.' + sections.$switcher.find('option:selected').data('step')).show();
            });
            sections.$steps.find('button.btn-next[data-step]').on('click', function(event) {
                event.preventDefault();
                var $button = $(this);
                var $step = $button.closest('section.step');
                $form.validate({fields: $step.find(selectors.controls)}, function(validated, response) {
                    if (response.success && $button.data('step')) {
                        sections.$steps.hide();
                        var section = sections.$steps.filter('.' + $button.data('step'));
                        section.find('select').trigger('change');
                        section.show();
                    }
                });
            });
            sections.$steps.find('button.btn-submit').on('click', function(event) {
                event.preventDefault();
                if ($form.validate({fields: $form.find(selectors.controls), data: {submit: true}}, function(validated, response) {
                    if (response.success) {
                        sections.$steps.hide();
                        if (response.message) {
                            sections.$error.hide();
                            sections.$success.find('.message').html(response.message);
                            sections.$success.show();                        
                        }
                        if (response.error) {
                            sections.$success.hide();
                            sections.$error.find('.message').html(response.error);
                            sections.$error.show();                        
                        }
                        sections.$feedback.show();
                    } 
                }));
            });
        });
    });
})(jQuery);